import { render, staticRenderFns } from "./VReminderCheckbox.vue?vue&type=template&id=25b2e173&"
import script from "./VReminderCheckbox.vue?vue&type=script&lang=js&"
export * from "./VReminderCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VReminderCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports